import { useMemo } from 'react';
import mediaQuery from '../../../../../helpers/mediaQuery';

function calculateAvailableViewportHeight(iosBottomPadding = 0): string {
  const headerElement = document.querySelector<HTMLElement>('.page-header');
  const promoBarElement = document.querySelector<HTMLElement>('.page-header-promo-bar');
  if (headerElement && promoBarElement) {
    const isHeaderFixed = headerElement?.classList.contains('page-header--fixed');
    const promoBarHeight = promoBarElement.offsetHeight || 0;
    const headerHeight = headerElement.offsetHeight || 0;

    const scrollYOverPromo = isHeaderFixed
      ? promoBarHeight
      : Math.abs(promoBarElement?.getBoundingClientRect().top || 0);
    const distanceToTheTop = headerHeight + promoBarHeight - scrollYOverPromo;
    const availableViewportHeight = window.innerHeight - distanceToTheTop;
    return `${availableViewportHeight + iosBottomPadding}px`;
  }

  return 'auto';
}

function useCalculateDropdownHeight(
  open: boolean,
  innerWidth: number,
  innerHeight: number,
  iosBottomPadding?: number
): { height: string; maxHeight: string } {
  return useMemo(() => {
    const isMediumUp = mediaQuery.isMediumUp();
    const availableViewportHeight = calculateAvailableViewportHeight(iosBottomPadding);

    if (!isMediumUp) {
      return { height: availableViewportHeight, maxHeight: availableViewportHeight };
    }

    return { height: 'auto', maxHeight: availableViewportHeight };
  }, [open, innerWidth, innerHeight]);
}

export default useCalculateDropdownHeight;
